import { HttpErrorResponse } from '@angular/common/http';

interface HttpErrorMessageOptions {
  service: string;
  operation: string;
  fallback: string;
}

export function getHttpErrorMessage(
  error: HttpErrorResponse,
  options: HttpErrorMessageOptions,
): string {
  const responseBody = error.error as Record<string, unknown> | null;
  const responseMessage = [responseBody?.['errorMessage'], responseBody?.['message']]
    .find((value): value is string => typeof value === 'string' && value.trim().length > 0)
    ?.trim();

  if (responseMessage) {
    return responseMessage;
  }

  switch (error.status) {
    case 0:
      return `Could not connect to the API server while ${options.operation}. Check that it is running and try again.`;
    case 502:
      return `The API gateway could not reach the ${options.service} (502 Bad Gateway). The API server may be unavailable; check that it is running and try again.`;
    case 503:
      return `The ${options.service} is temporarily unavailable (503 Service Unavailable). Try again shortly.`;
    case 504:
      return `The ${options.service} did not respond in time (504 Gateway Timeout). Try again shortly.`;
    default:
      return options.fallback;
  }
}
